// extracted by mini-css-extract-plugin
module.exports = {"vGutterX":"30px","vPageVerticalGapTop":"20px","tablet-landscape-up":"(min-width: calc(1024 * 1px))","page":"Page_page__2P4mN"};